import history from '../../../../../history'
import { InfoSvg } from '../../../../../svgs'
import { OverlayPanel } from '../../../Routing'
import { HomeValueEstimatePanel } from '../Panel'
import { useIntl, defineMessages } from 'react-intl'
import { Button } from '@homebotapp/hb-react-component-catalog'
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import { useTrackingContext } from '../../../../../providers/tracking'

export const MSG = defineMessages({
  button: {
    id: 'HomeValueEstimate.button.title',
    defaultMessage: 'Learn about home estimates'
  }
})

export const HomeValueEstimateButton = ({ tracking }) => {
  const { trackingClient } = useTrackingContext()
  const intl = useIntl()
  const handleOnClick = () => {
    trackingClient?.avmInfoViewed()
    history.push(OVERLAY_HELPERS.homeValueEstimate.buildPath())
  }

  return (
    <>
      <Button
        variant='ghost'
        colorScheme='primary'
        size='sm'
        marginY={2}
        onClick={handleOnClick}
        leftIcon={<InfoSvg />}
        tracking={{
          ...tracking,
          descriptor: MSG.button.defaultMessage
        }}
      >
        {intl.formatMessage(MSG.button)}
      </Button>
      <OverlayPanel
        back={OVERLAY_HELPERS.homeValueEstimate.getOrigin()}
        path={OVERLAY_HELPERS.homeValueEstimate.buildPath()}
        title={OVERLAY_HELPERS.getTitle('homeValueEstimate', intl.formatMessage)}
        anchorOffset={200}
        component={HomeValueEstimatePanel}
      />
    </>
  )
}
